export const COUNTRIES = ['Afghanistan', 'Albania', 'Algeria', 'Andorra', 'Angola', 'Antigua and Barbuda', 'Argentina', 'Armenia', 'Aruba', 'Australia', 'Austria', 'Azerbaijan', 'Bahamas, The', 'Bahrain', 'Bangladesh', 'Barbados', 'Belarus', 'Belgium', 'Belize', 'Benin', 'Bhutan', 'Bolivia', 'Bosnia and Herzegovina', 'Botswana', 'Brazil', 'Brunei', 'Bulgaria', 'Burkina Faso', 'Burma', 'Burundi', 'Cambodia', 'Cameroon', 'Canada', 'Cabo Verde', 'Central African Republic', 'Chad', 'Chile', 'China', 'Colombia', 'Comoros', 'Congo, Democratic Republic of th ', 'Congo, Republic of the', 'Costa Rica', 'Cote d\'Ivoire', 'Croatia', 'Cuba', 'Curacao', 'Cyprus', 'Czechia', 'Denmark', 'Djibouti', 'Dominica', 'Dominican Republic', 'East Timor (see Timor-Leste)', 'Ecuador', 'Egypt', 'El Salvador', 'Equatorial Guinea', 'Eritrea', 'Estonia', 'Ethiopia', 'Fiji', 'Finland', 'France', 'Gabon', 'Gambia, The', 'Georgia', 'Germany', 'Ghana', 'Greece', 'Grenada', 'Guatemala', 'Guinea', 'Guinea-Bissau', 'Guyana', 'Haiti', 'Holy See', 'Honduras', 'Hong Kong', 'Hungary', 'Iceland', 'India', 'Indonesia', 'Iran', 'Iraq', 'Ireland', 'Israel', 'Italy', 'Jamaica', 'Japan', 'Jordan', 'Kazakhstan', 'Kenya', 'Kiribati', 'Korea, North', 'Korea, South', 'Kosovo', 'Kuwait', 'Kyrgyzstan', 'Laos', 'Latvia', 'Lebanon', 'Lesotho', 'Liberia', 'Libya', 'Liechtenstein', 'Lithuania', 'Luxembourg', 'Macau', 'Macedonia', 'Madagascar', 'Malawi', 'Malaysia', 'Maldives', 'Mali', 'Malta', 'Marshall Islands', 'Mauritania', 'Mauritius', 'Mexico', 'Micronesia', 'Moldova', 'Monaco', 'Mongolia', 'Montenegro', 'Morocco', 'Mozambique', 'Namibia', 'Nauru', 'Nepal', 'Netherlands', 'New Zealand', 'Nicaragua', 'Niger', 'Nigeria', 'North Korea', 'Norway', 'Oman', 'Pakistan', 'Palau', 'Palestinian Territories', 'Panama', 'Papua New Guinea', 'Paraguay', 'Peru', 'Philippines', 'Poland', 'Portugal', 'Qatar', 'Romania', 'Russia', 'Rwanda', 'Saint Kitts and Nevis', 'Saint Lucia', 'Saint Vincent and the Grenadines', 'Samoa', 'San Marino', 'Sao Tome and Principe', 'Saudi Arabia', 'Senegal', 'Serbia', 'Seychelles', 'Sierra Leone', 'Singapore', 'Sint Maarten', 'Slovakia', 'Slovenia', 'Solomon Islands', 'Somalia', 'South Africa', 'South Korea', 'South Sudan', 'Spain', 'Sri Lanka', 'Sudan', 'Suriname', 'Swaziland', 'Sweden', 'Switzerland', 'Syria', 'Taiwan', 'Tajikistan', 'Tanzania', 'Thailand', 'Timor-Leste', 'Togo', 'Tonga', 'Trinidad and Tobago', 'Tunisia', 'Turkey', 'Turkmenistan', 'Tuvalu', 'Uganda', 'Ukraine', 'United Arab Emirates', 'United Kingdom', 'United States', 'Uruguay', 'Uzbekistan', 'Vanuatu', 'Venezuela', 'Vietnam', 'Yemen', 'Zambia', 'Zimbabwe'];
export const TICKET_STATUSES = ['sold', 'reserved', 'returned', 'no_show', 'canceled'];
export const USER_ROLES = ['ROLE_ROOT_ADMIN', 'ROLE_ADMIN', 'ROLE_SALES_MANAGER', 'ROLE_ANALYST', 'ROLE_HEAD_SALES_MANAGER'];

const VALIDATION_MESSAGES = {
  flightGroup: { required: 'Flight group is required' },
  flightNumber: { required: 'Flight number is required.' },
  departure: { required: 'Departure is required.' },
  destination: { required: 'Destination is required.' },
  priceFull: {
    required: 'Price full is required.',
    min: 'Price must be greater than 1.'
  },
  priceChild: {
    required: 'Price child is required.',
    min: 'Price must be greater than 1.'
  },
  priceInfant: {
    required: 'Price infant is required.',
    min: 'Price must be greater than 0.'
  },
  aircraft: { required: 'Aircraft is required.' },
  aircraftName: { required: 'Aircraft name is required.' },
  seatsTotal: {
    required: 'Seats total is required.',
    min: 'Seats total must be greater than -1'
  },
  seatsOnlineTotal: {
    required: 'Seats online total is required.',
    min: 'Seats online total must be greater then -1'
  },
  fromDate: { required: 'From date is required.' },
  toDate: { required: 'To date is required.' },
  dateTime: { required: 'Date is required.' },
  timeDate: { required: 'Time is required.' }
};

import * as moment from 'moment';
import { FormControl } from '@angular/forms';

export class Helper {

  private orderBy: string;

  formatDate(date: any): string {
    if (typeof date !== 'object' || date === null) {
      return date;
    }
    const _date = Object.assign({}, date, {
      month: date.month - 1
    });
    console.log(_date);
    return moment.utc(_date).format();
  }

  formatStringToDate(date: any) {
    if (date.indexOf(':') >= 0) {
      return date;
    }
    const dArray = date.split('-');
    const d = dArray[0];
    dArray[0] = dArray[1];
    dArray[1] = d;
    const _date = dArray.join('-');
    return moment.utc(_date).format();
  }

  formatFilterDate(date: any, format: string = 'DD.MM.YYYY'): any {
    if (typeof date !== 'object' || date === null) {
      return date;
    }
    const _date = Object.assign({}, date, {
      month: date.month - 1
    });
    return moment(_date).format(format);
  }

  formatDateTime(date: any, time: string) {
    const _date = Object.assign({}, date, {
      month: date.month - 1
    });
    const timeArr = time.split(':');
    const momentedDate = moment
      .utc(_date)
      .add(timeArr[0], 'h')
      .add(timeArr[1], 'm')
      .format();

    console.log(momentedDate);
    return momentedDate;
  }

  getPersonAge(birthday: any, flightDate: string) {
    return DateValidator.getPersonAge(birthday, flightDate);
  }

  getDateTime(date: any) {
    const _date = new Date(date);
    return {
      date: { year: _date.getFullYear(), month: _date.getMonth() + 1, day: _date.getDate() },
      time: moment(_date).format('HH:mm')
    };
  }


  getTicketPersonDate(date: any) {
    const _date = new Date(date);
    return moment(_date).format('DD-MM-YYYY');
  }

  formatTicketPersonDate(date: string) {
    console.log(date);
    return moment.utc(date, 'DD-MM-YYYY').format();
  }

  setPrefix(data: any, formValue: any): any {
    const FV = Object.assign({}, formValue, formValue);
    for (let i = 0; i < data.length; i++) {
      const key = data[i].name;
      const val = formValue[data[i].name];
      if (key && val) {
        FV[key] = !FV[key].month ? data[i].pre + FV[key] : data[i].pre + this.formatFilterDate(FV[key]);
      }
    }
    return FV;
  }

  getOrderStr(e: any): string {
    const orderName = e.target.getAttribute('order-name');
    if (orderName) {
      const orderBy = `?order[${orderName}]=DESC`;
      this.orderBy === orderBy ? (this.orderBy = `?order[${orderName}]=ASC`) : (this.orderBy = `?order[${orderName}]=DESC`);
      return this.orderBy;
    }
    return '';
  }

  clearEmptyFormFilds(formValue: any): any {
    for (const key in formValue) {
      if (formValue.hasOwnProperty(key)) {
        const element = formValue[key];
        if (!element) {
          delete formValue[key];
        }
      }
    }
    return formValue;
  }

  getValidationMessages() {
    return VALIDATION_MESSAGES;
  }

  autoDateFormat(input: string) {
    if (/\D\/$/.test(input)) {
      input = input.substr(0, input.length - 3);
    }
    const values = input.split('-').map(function (v) {
      return v.replace(/\D/g, '');
    });
    if (values[0]) {
      values[0] = this.dateCheckValue(values[0], 31);
    }
    if (values[1]) {
      values[1] = this.dateCheckValue(values[1], 12);
    }
    const output = values.map(function (v, i) {
      return v.length === 2 && i < 2 ? v + '-' : v;
    });
    return output.join('').substr(0, 14);
  }

  dateCheckValue(str: string, max: number) {
    if (str.charAt(0) !== '0' || str === '00') {
      let num = parseInt(str, 10);
      if (isNaN(num) || num <= 0 || num > max) {
        num = 1;
      }
      str = num > parseInt(max.toString().charAt(0), 10) && num.toString().length === 1 ? '0' + num : num.toString();
    }
    return str;
  }

}


export class DateValidator {
  constructor(
  ) { }
  static date(c) {
    const dateRegEx = new RegExp(/^\d{2}\-\d{2}\-\d{4}$/);
    return dateRegEx.test(c.value) ? { date: false } : { date: true };
  }
  static infuntDate(flightDates: string[], type: string) {
    return (control: any) => {
      if (type === 'Adult') {
        return null;
      }
      const val = control.value;
      for (const date of flightDates) {
        const personAge = DateValidator.getPersonAge(val, date);
        // console.log('cheking>>>', date, val, personAge);
        if (personAge >= 3) {
          return { infuntDate: true };
        }
      }
      return null;
    };
  }

  static getPersonAge(birthday: any, flightDate: string) {
    if (DateValidator.date({ value: birthday }).date) {
      return 99;
    }
    return moment(flightDate).diff(moment(birthday, 'DD-MM-YYYY'), 'years');
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/helper.ts